import { render, staticRenderFns } from "./IntegrationCardSkeleton.vue?vue&type=template&id=1e722116&scoped=true&"
import script from "./IntegrationCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./IntegrationCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationCardSkeleton.vue?vue&type=style&index=0&id=1e722116&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e722116",
  null
  
)

export default component.exports